import  { useState, useEffect } from 'react';
import Pagination from '@mui/material/Pagination';
import { API_URLS } from '../../../apiUrl';
import { Link } from 'react-router-dom';
import StreetWiseHoldingNo from '../holdingNo/streetWiseHoldingNo';
import Consumerlist from '../../waterSupply/UserComponents/SuperAdmin/Consumerlist';
import axiosInstance from '../../../components/axiosInstance';

const WardWiseStreet = ({ boroughId, municipalityId, wardId, breadCrumbStreet, breadcrumbBorrow, municipalityName }: any) => {

    type FormData = {
        municipalityTbl_id: any;
        page: number;
        limit: number;
    };

    const [tableData, setTableData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);

    const [inputData, setInputData] = useState({ page: 1, limit: 50 });
    const [totalItems, setTotalItems] = useState(0);
    const [itemsPerPage] = useState(50);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const data = {
                    municipalityTbl_id: municipalityId,
                    ward_primary_id: String(wardId),
                    page: inputData.page,
                    limit: inputData.limit,
                    surveyer_id: 0
                };
                const response = await axiosInstance.post(`${API_URLS.GetWardWiseStreet}`, data);

                if (response.data.data.data) {
                    setTableData(response.data.data.data);
                    setTotalItems(response.data.data.count);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [inputData.page]);

    const filteredData = tableData.filter((item: any) =>
        item.street_name?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const onRedirect = () => {
        breadCrumbStreet(false);
    }

    const onRedirectBorrow = () => {
        breadcrumbBorrow(false);
    }

    const [isWardView, setWardView] = useState(false);
    const [isStreetView, setStreetView] = useState(false);

    const handleHoldingView = (streetId: any) => {
        setWardView(true);
        setStreetView(streetId);
    };

    const [isConsumerView, setIsConsumerView] = useState(false)
    const [isConsumerId, setIsConsumerId] = useState<number>(0);

    const handleConsumerView = (streetId: any) => {
        setIsConsumerView(true)
        setIsConsumerId(streetId)
    }

    const handlePageChange = (event: any, value: number) => {
        setInputData((prevData) => ({
            ...prevData,
            page: value,
        }));
    };

    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const isRole = localStorage.getItem('role_type')

    return (
        <>
            {isConsumerView ?
                <Consumerlist
                    onRedirectBorrow={onRedirectBorrow}
                    onRedirectWard={() => { }}
                    onRedirect={onRedirect}
                    StreetId={isConsumerId}
                    municipalityId={municipalityId}
                /> : isWardView ? <StreetWiseHoldingNo
                    streetViewId={isStreetView}
                    municipalityId={municipalityId}
                    breadCrumbHolding={setWardView}
                    breadCrumbWard={breadCrumbStreet}
                    breadCrumbBorrow={breadcrumbBorrow}
                    municipalityName={municipalityName} /> :
                    <>
                        <nav className="bg-gradient-to-r from-gray-200 to-gray-100 py-3 px-4 mb-3 rounded-lg">
                            <ul className="flex items-center space-x-4 text-sm text-gray-700">
                                {
                                    isRole !== 'Municipality Admin' && (
                                        <>
                                            <li>
                                                <Link to="/dashboard/overview" className="hover:text-blue-600 hover:underline transition duration-300 ease-in-out">
                                                    Home
                                                </Link>
                                            </li>
                                            <li>
                                                <span className="text-gray-400">/</span>
                                                <button onClick={onRedirect} className="hover:text-blue-600 hover:underline transition duration-300 ease-in-out ml-2">
                                                    Municipalities
                                                </button>
                                            </li>
                                        </>
                                    )
                                }
                                <li>
                                    {isRole !== 'Municipality Admin' && (
                                        <span className="text-gray-400">/</span>
                                    )}
                                    <button onClick={onRedirectBorrow} className="hover:text-blue-600 hover:underline transition duration-300 ease-in-out ml-2">
                                        Borough
                                    </button>
                                </li>

                                <li>
                                    <span className="text-gray-400">/</span>
                                    <button onClick={onRedirect} className="hover:text-blue-600 hover:underline transition duration-300 ease-in-out ml-2">
                                        Ward
                                    </button>
                                </li>

                                <li>
                                    <span className="text-gray-400">/</span>
                                    <span className="font-semibold text-gray-800 ml-2">Street</span>
                                </li>
                            </ul>
                        </nav>

                        <div className="container mx-auto">
                            <div className="flex gap-5 mb-4">
                                <h1 className="text-2xl font-semibold text-gray-800 dark:text-gray-100">Streets List ({municipalityName})</h1>

                                <div className="flex justify-end md:w-4/12 w-full ml-auto">
                                    <input
                                        type="text"
                                        placeholder="Search..."
                                        className="border px-3 py-2 rounded-lg w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-900 dark:bg-gray-800"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="overflow-x-auto bg-white rounded-lg shadow-lg border border-gray-200 dark:border-gray-800">
                                <table className="min-w-full table-auto">
                                    <thead className="bg-gray-100 border-b dark:border-gray-600 dark:bg-gray-700">
                                        <tr>
                                            <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Street Name</th>
                                            <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Street Number</th>
                                            <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Created At</th>
                                            <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Updated At</th>
                                            <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Holding</th>
                                            <th className="py-3 px-6 text-left text-sm font-medium text-gray-600 dark:text-gray-100">Connection</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan={6} className="py-3 px-6 text-center">Loading...</td>
                                            </tr>
                                        ) : filteredData.length === 0 ? (
                                            <tr>
                                                <td colSpan={6} className="py-3 px-6 text-center dark:bg-gray-800">No results found</td>
                                            </tr>
                                        ) : (
                                            filteredData.map((item: any, index) => (
                                                <tr key={index} className="border-b dark:border-gray-700 hover:bg-gray-50">
                                                    <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.street_name || 'N/A'}</td>
                                                    <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">{item.street_no || 'N/A'}</td>
                                                    <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">
                                                        {item.created_at ? new Date(item.created_at).toLocaleString() : new Date().toLocaleString()}
                                                    </td>
                                                    <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">
                                                        {item.updated_at ? new Date(item.updated_at).toLocaleString() : new Date().toLocaleString()}
                                                    </td>
                                                    <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">
                                                        <button onClick={() => handleHoldingView(item.street_primary_id)} className="ml-2">
                                                            <img src="/assets/boroughIcon.png" alt="Icon" className="w-5 h-5" />
                                                        </button>
                                                    </td>
                                                    <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 dark:bg-gray-600">
                                                        <button onClick={() => handleConsumerView(item.street_primary_id)} className="ml-2">
                                                            <img src="/assets/boroughIcon.png" alt="Icon" className="w-5 h-5" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {filteredData?.length === 0 ? null :
                                <div className="flex justify-center mt-4">
                                    <Pagination
                                        count={totalPages}
                                        page={inputData.page}
                                        onChange={handlePageChange}
                                        color="primary"
                                    />
                                </div>}
                        </div></>} </>

    );
};

export default WardWiseStreet;